<script>
export default {
  name: 'ProductInformationTab',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      if (this.product.active) {
        return 'active'
      }

      return 'inactive'
    },
  },
}
</script>

<template>
  <data-box
    header="Product Details"
    :status="status"
  >
    <data-list>
      <dt>Date Created</dt>
      <dd>{{ product.createdAt | dateTime }}</dd>

      <dt>Last Updated</dt>
      <dd>{{ product.updatedAt | dateTime }}</dd>

      <dt>Product ID</dt>
      <dd>{{ product.id }}</dd>

      <dt>Product Name</dt>
      <dd>{{ product.name }}</dd>

      <dt>Product URL</dt>
      <dd>
        <a
          :href="product.url"
          target="_blank"
        >
          {{ product.url }}
        </a>
      </dd>

      <dt>Auth0 External ID</dt>
      <dd>{{ product.externalId || '—' }}</dd>

      <dt>Product Logo</dt>
      <dd
        v-if="product.logo"
        :class="$style.logo"
        :style="`background-image: url('${product.logo}')`"
      />
      <dd v-else>
        —
      </dd>

      <dt>Product Description</dt>
      <dd>{{ product.description }}</dd>

      <dt>Product Category</dt>
      <dd>{{ product.category.name }}</dd>
    </data-list>
  </data-box>
</template>

<style lang="scss" module>
.logo {
  height: rem(65px);
  padding: 0;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  background-repeat: no-repeat;
  background-position: center left;
  background-size: contain;
}

</style>
